module.exports = __webpack_public_path__ + "img/spinner_dualball.64ed4f83.svg";